<div *ngIf="!!issue.marketplaceUrl; else noMarketplaceUrlBlock">
  This resource is based on a product from the AWS Marketplace, and must be licensed in the recovery account before it
  can be replicated. Visit the AWS Marketplace while logged into the recovery account to subscribe to this product:
  <a target="_blank" [href]="issue.marketplaceUrl">{{ issue.marketplaceUrl }}</a>
</div>
<ng-template #noMarketplaceUrlBlock>
  {{ issue.message }}
</ng-template>
